import { Attendance } from '../constants/attendance-constants.js';

const initState = {
	attendanceDataStatus: 'unload',
	attendanceData: [],
	companyCalendar: {
		filters: {},
		data: [],
		dataStatus: "unload"
	},
	attendanceTemplate: {
		filters: {
			page: 1
		},
		data: [],
		dataStatus: "unload",
		loadCounter: 0
	},
	vacationManagement: {
		filters: {
			page: 1
		},
		data: [],
		dataStatus: "unload",
		loadCounter: 0
	}
}

export default function attendance(state = initState, action) {
	switch (action.type) {
		// attendance schedule
		case Attendance.ActionTypes.FETCHATTENDANCESCHEDULESUCCESS:
			return { ...state, ...action.payload };
		case Attendance.ActionTypes.FETCHATTENDANCESCHEDUSCHEDULEUCCESS:
			// return { ...state, ...action.payload };
			// console.log()
			return {
				...state,
				attendanceTemplate: {
					...state.attendanceTemplate,
					schedules: action.payload.schedules,
				}
			}
		case Attendance.ActionTypes.UPDATEATTENDANCESCHEDULESUCCESS:
			let copyUPdateAttendanceData = { ...state};
			copyUPdateAttendanceData.attendanceData[action.payload.index] = action.payload.value;
			return copyUPdateAttendanceData;
		// attendance template
		case Attendance.ActionTypes.CHANGEATTENDANCETEMPLATE:
			return {
				...state,
				attendanceTemplate: {
					...state.attendanceTemplate,
					filters: {
						...state.attendanceTemplate.filters,
						...action.payload.filters
					},
					dataStatus: action.payload.status,
					loadCounter: state.attendanceTemplate.loadCounter + action.payload.counter
				}
			};
		case Attendance.ActionTypes.FETCHATTENDANCETEMPLATESUCCESS:
			return {
				...state,
				attendanceTemplate: {
					...state.attendanceTemplate,
					data: action.payload.data,
					schedules: action.payload.schedules,
					dataStatus: "loaded"
				}
			};
		case Attendance.ActionTypes.UPDATEATTENDANCETEMPLATESUCCESS:
			let copyData = state.attendanceTemplate.data.Data;
			copyData[action.payload.index] = action.payload.value;
			console.log(copyData);
			return {
				...state,
				attendanceTemplate: {
					...state.attendanceTemplate,
					data: {
						...state.attendanceTemplate.data,
						Data: copyData
					}
				}
			}
		// case Attendance.ActionTypes.FETCHATTENDANCETEMPLATESUCCESS:
		// 	return { ...state, ...action.payload };
		// case Attendance.ActionTypes.UPDATEATTENDANCETEMPLATESUCCESS:
		// 	let copyUPdateAttendanceTemplateData = { ...state};
		// 	copyUPdateAttendanceTemplateData.attendanceData[action.payload.index] = action.payload.value;
		// 	return copyUPdateAttendanceTemplateData;
		// case Attendance.ActionTypes.INITIALIZATIONSUCCESS:
		// 	return { ...state, ...action.payload };
		// others
		case Attendance.ActionTypes.FETCHANNUALLEAVESUCCESS:
			return { ...state, ...action.payload };
		case Attendance.ActionTypes.UPDATEANNUALLEAVESUCCESS:
			let copyUpdateAnnualLeaveState = { ...state };
			copyUpdateAnnualLeaveState.employeeList.Data[action.payload.index] = action.payload.value;
			return copyUpdateAnnualLeaveState;
		// company calendar
		case Attendance.ActionTypes.FETCHCOMPANYCALENDARLISTSUCCESS:
			return {
				...state,
				companyCalendar: {
					...state.companyCalendar,
					data: action.payload.data,
					dataStatus: "loaded"
				}
			}
		// crew rostering
		case Attendance.ActionTypes.FETCHCREWROSTERINGLISTSUCCESS:
			return { ...state, ...action.payload };
		case Attendance.ActionTypes.UPDATEATCREWROSTERINGSUCCESS:
			return {...state, ...action.payload};
		case Attendance.ActionTypes.EXPORTCREWROSTERINGSSUCCESS:
           return {...state, ...action.payload};
        //  attendance record
        case Attendance.ActionTypes.FETCHATTENDANCERECORD:
			return { ...state, ...action.payload };
			case Attendance.ActionTypes.FETCHEXCEPTIONATTENDANCERECORD:
			return { ...state, ...action.payload };
		case Attendance.ActionTypes.UPDATEATTENDANCERECORDSUCCESS:
			return { ...state, ...action.payload };
		case Attendance.ActionTypes.EXPORTATTENDANCERECORDSSUCCESS:
		   return {...state, ...action.payload};
		   case Attendance.ActionTypes.EXPORTATTENDANEXCEPTIONCERECORDSSUCCESS:
           return {...state, ...action.payload};
		// vacation management
		case Attendance.ActionTypes.CHANGEVACATIONMANAGEMENT:
			return {
				...state,
				vacationManagement: {
					...state.vacationManagement,
					filters: {
						...state.vacationManagement.filters,
						...action.payload.filters
					},
					dataStatus: action.payload.status,
					loadCounter: state.vacationManagement.loadCounter + action.payload.counter
				}
			}

		case Attendance.ActionTypes.SELECTVACATIONMANAGEMENT:
			return {
				...state,
				vacationManagement: {
					...state.vacationManagement,
					data: action.payload.data,
					dataStatus: action.payload.status
				}
			}

		case Attendance.ActionTypes.UPDATEVACATIONMANAGEMENT:
			return {
				...state,
				vacationManagement: {
					...state.vacationManagement,
					data: {
						...state.vacationManagement.data,
						Data: [
							...state.vacationManagement.data.Data.slice(0, action.payload.index),
							action.payload.data,
							...state.vacationManagement.data.Data.slice(action.payload.index + 1)
						]
					}
				}
			}

		default :
			return state;
	}
}


// WEBPACK FOOTER //
// ./src/reducers/attendance-reducer.js